import { PublicClientApplication, LogLevel } from "@azure/msal-browser";

const AZURE_CLIENT_ID = "b33f3697-e714-4788-ac7d-1e710696a4e4";
const AZURE_TENANT_ID = "a98d3dc3-3fe7-4bb3-a9fe-c509a7c9f071";

// Detect if running inside an iframe
const isInIframe = window !== window.parent;

export const msalConfig = {
  auth: {
    clientId: AZURE_CLIENT_ID,
    authority: `https://login.microsoftonline.com/${AZURE_TENANT_ID}`,
    redirectUri: window.location.origin + "/auth/callback",
    postLogoutRedirectUri: window.location.origin + "/login",
    navigateToLoginRequestUrl: true,
  },
  cache: {
    cacheLocation: "localStorage",
    storeAuthStateInCookie: true,
  },
  system: {
    allowRedirectInIframe: true,
    iframeHashTimeout: 10000,
    windowHashTimeout: 60000,
    loadFrameTimeout: 10000,
    asyncPopups: false,
    loggerOptions: {
      loggerCallback: (level, message, containsPii) => {
        if (containsPii) return;
        if (level === LogLevel.Error) console.error("MSAL:", message);
      },
    },
  },
};

export const loginRequest = {
  scopes: ["openid", "profile", "email", "User.Read"],
};

// Use popup when in iframe, redirect when standalone
export const usePopupLogin = isInIframe;

export const msalInstance = new PublicClientApplication(msalConfig);
